<template>
  <q-markup-table>
    <thead>
      <slot name="thead" />
    </thead>
    <tbody>
      <template v-for="(row, index) in rows" :key="rowId">
        <slot name="body" v-bind="{ row, index }" />
      </template>
    </tbody>
    <tfoot>
      <slot name="foot" />
    </tfoot>
  </q-markup-table>
</template>

<script lang="js" setup>
const props = defineProps({
  rowId: String,
  rows: { type: Array, default: () => [] }
})
</script>